export enum ErrorRoutes {
  Unexpected = 'unexpected',
  NotFound = '**',
}
